import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SearchEntityLevels} from '../../../shared/types/nso-data-portal/search-entity-levels';

@Component({
  selector: 'wsd-census-widget',
  templateUrl: './census-widget.component.html',
  styleUrls: ['./census-widget.component.css']
})
export class CensusWidgetComponent {

  @Input()
  organizationId: number;

  @Input()
  entityLevel: SearchEntityLevels;

  @Input()
  expanded: boolean;

  @Input()
  isFederation: boolean;

  @Output()
  sizeChanged = new EventEmitter<any>();

  censusUpdatedLastYear = true;

  searchEntityLevels = SearchEntityLevels;

  constructor() {
  }

  initCensusUpdatedLastYear(event) {
    this.censusUpdatedLastYear = event.censusUpdatedLastYear;
  }
}
